import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { PAGE_ROUTE, API_URL } from '../shared/constant';
import LoaderComponent from '../shared/loader';

const TechnicalSpecificationForm = () => {

    let navigate = useNavigate();
    let { id } = useParams();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState([]);
    const [title, setTitle] = useState('')
    const [parameters, setParameters] = useState([{
        parameter: '',
        property:'',
        value: '',
        title: '',
    }])

    useEffect(() => {
        if (id) {
            onEdit();
        }
    }, []);


    const onSubmit = (e) => {
        e.preventDefault();
        if (isInvalid(title)) {
            toast.error("Title Is Required");
            return false;
        }

        setError([]);
        setLoading(true);
        let url = API_URL.ADMIN_TECHNICAL_SPECIFICATION_SAVE;
        let body = {
            id: null,
            title: title,
            parameters: parameters
        };
        if (id) {
            body['id'] = id;
            url = API_URL.ADMIN_TECHNICAL_SPECIFICATION_UPDATE;
        }
        axios.post(url, body).then((response) => {
            setLoading(false);
            if (response.data.status === 1) {
                if (id) {
                    toast.success('Techincal Specification Updated Successfully', { autoClose: 3000 });
                } else {
                    toast.success('Techincal Specification Created Successfully', { autoClose: 3000 });
                }
                setTimeout(() => {
                    navigate(PAGE_ROUTE.ADMIN_TECHNICAL_SPECIFICATION_LIST, { replace: true });
                }, 100);
            } else {
                if (response.data && response.data.data) {
                    let errors = [];
                    Object.keys(response.data.data).forEach((key) => {
                        errors.push(response.data.data[key][0]);
                    });
                    setError(errors);
                    toast.error('Something went wrong..', { autoClose: 3000 })
                }
            }
        }, (error) => {
            setLoading(false);
            toast.error('Something went wrong..', { autoClose: 3000 })
        });
    }

    const isInvalid = (value) => {
        return (!value || value === '' || value == null);
    };


    const onEdit = () => {
        axios.post(API_URL.ADMIN_TECHNICAL_SPECIFICATION_GET + id).then((response) => {
            if (response.data.status === 1) {
                setTitle(response.data.data.title);
                setParameters(JSON.parse(response.data.data.detail));
            }
        });
    }

    const addParameter = () => {
        let pr = [...parameters]
        pr.push({
            parameter: '',
            value: '',
            property:''
        })
        setParameters(pr)
    }

    const removeParameter = (i) => {
        let pr = [...parameters]
        pr.splice(i, 1)
        setParameters(pr)
    }

    const updateValue = (i, name, value) => {
        let pr = [...parameters]
        if (pr[i]) {
            pr[i][name] = value;
        }
        setParameters(pr)
    }


    return (
        <div className="card">
            <div className="card-body">
                <h4 className="card-title">{id ? 'Edit' : 'Add'} Techincal Specification
                    {error.length > 0 &&
                        <>
                            {[
                                'danger',
                            ].map((variant) => (
                                <Alert key={variant} variant={variant}>
                                    {error.map((element, key) => {
                                        return (
                                            <div key={key}>{element}</div>
                                        )
                                    })}
                                </Alert>
                            ))}
                        </>
                    }
                </h4>
                <form className="forms-sample" onSubmit={onSubmit}>
                    <div className='row'>
                        <div className='col-md-8'>
                            <div className="form-group">
                                <label htmlFor="name">Title</label>
                                <input type="text"
                                    title='title'
                                    className="form-control"
                                    value={title}
                                    id="title"
                                    onChange={(event) => {
                                        setTitle(event.target.value)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {parameters.map((item, i) => {
                        return <div className='row' key={i}>
                            <div className='col-md-4'>
                                <div className="form-group">
                                    <label htmlFor="name">Property</label>
                                    <input type="text"
                                        name='property'
                                        className="form-control"
                                        value={item.property}
                                        id="name"
                                        onChange={(event) => {
                                            updateValue(i, 'property', event.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-group">
                                    <label htmlFor="name">Parameter</label>
                                    <input type="text"
                                        name='parameter'
                                        className="form-control"
                                        value={item.parameter}
                                        id="parameter"
                                        onChange={(event) => {
                                            updateValue(i, 'parameter', event.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className="form-group">
                                    <label htmlFor="name">Value</label>
                                    <input type="text"
                                        name='value'
                                        className="form-control"
                                        value={item.value}
                                        id="name"
                                        onChange={(event) => {
                                            updateValue(i, 'value', event.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-group">
                                    <label className='d-block' >&nbsp;</label>
                                    {(i === 0) ?
                                        <button className="btn btn-primary" type='button'
                                            onClick={addParameter}>Add</button> :
                                        <button className="btn btn-danger" type='button'
                                            onClick={() => removeParameter(i)}>Delete</button>
                                    }
                                </div>
                            </div>
                        </div>
                    })}
                    <div className='text-end mt-3 pt-3 border-top'>
                        {
                            isLoading && <LoaderComponent type={'watch'} height={35} width={35}></LoaderComponent>
                        }
                        <button type="submit" className="btn btn-primary">{id ? 'Update' : 'Create'}</button>
                        <NavLink to={PAGE_ROUTE.ADMIN_TECHNICAL_SPECIFICATION_LIST} className="btn btn-secondary">
                            Cancel
                        </NavLink>
                    </div>
                </form>
            </div>
        </div>
    );

}
export default TechnicalSpecificationForm;